import { Component, NgZone, OnInit } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { LoadingController, ModalController } from '@ionic/angular';
import { loadOpt } from 'src/environments/environment';
import { CartService } from '../cart.service';
import { Globals } from '../globals';
import { MapComponent } from '../map/map.component';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';

declare var google;

@Component({
  selector: 'app-adress',
  templateUrl: './adress.page.html',
  styleUrls: ['./adress.page.scss'],
})
export class AdressPage implements OnInit {

  address: string = '';
  address2: string = '';
  lat: string = '';
  lng: string = '';
  postal_code: string = '';
  view: boolean = false;
  number: string = '';
  door: string = '';

  autocomplete: { 
    input: string; 
  };

  autocompleteItems: any[];
  GoogleAutocomplete: any;
  placesService: any;

  constructor(
    public modalCtrl: ModalController,
    private stop: LoadingController,
    private nativeGeocoder: NativeGeocoder,
    public user: UserService,
    private geolocation: Geolocation,
    public service: CartService,
    public rest: RestService,
    public zone: NgZone,
    public global: Globals
    ) {
      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
      this.autocompleteItems = [];
      this.autocomplete = { input: '' };
    }

  ngOnInit() { this.GetAdresses(); }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  segmentChanged(event){
    if ( event.detail.value === '0'){
      this.view = true;
    } else {
      this.view = false;
    }

  }

  AddAdress(){
    const calle = document.getElementById('address') as HTMLInputElement;
    this.address = calle.value;
    this.lat = this.global.lat;
    this.lng = this.global.lng;
    this.number = this.number.trim();
    if(this.address==''){
      this.user.generateToast('Campo Calle obligatorio');
      return false;
    }

    if(this.number==''){
      this.user.generateToast('Campo Número obligatorio');
      return false;
    }

    if(this.postal_code==''){
      this.user.generateToast('Campo Código Postal obligatorio');
      return false;
    }

    if(this.number!='' && this.address!='' && this.postal_code!=''){

    this.rest.getDeliveryPrice('0', this.postal_code, this.service.total)
      .subscribe( (data) => {

        this.rest.addAdress(this.address, this.number, this.door, this.postal_code, this.lat, this.lng)
              .subscribe( (data) => {
                this.rest.getAdress()
                    .subscribe((data) => {
                      this.user.adressesUser = data['data'];
                      this.user.adressSelected = data['data'].length - 1;
                      this.dismiss();
                    });

              });
      },
      (error) => this.user.generateToast(error.error.data));

    }else{
      this.user.generateToast('Revisa los campos');
    }

    this.GetAdresses();
    this.global.lat = ''
    this.global.lng = ''

  }

  PredeterminateAdress(index){

    this.rest.predeterminateAdress(this.user.adressesUser[index].id_address)
    .subscribe(
      (data) => {
        this.user.generateToast('Direccion predeterminada');
        this.GetAdresses();
      },
      (error) => this.user.generateToast(error.error.message));
  }

  showMsg(){
    this.user.generateToast('Desliza para ver las opciones');
  }

  RemoveAdress(index){
    this.rest.removeAdress(this.user.adressesUser[index].id_address).subscribe(
      (adresses) => {
        this.user.generateToast('Domicilio eliminado');
        this.user.adressesUser.splice(index, 1);
      },
      (error) => this.user.generateToast(error.error.message));
  }

  GetAdresses(){
    this.rest.getAdress().subscribe(
      (data) => {
        this.user.adressesUser = data['data'];
      },
    (error) => this.user.generateToast(error.error.message));
  }

  whereIAm(){
    this.geolocation.getCurrentPosition()
    .then((resp) => {
      this.getAddressFromCoords(resp.coords.latitude, resp.coords.longitude);
     }).catch((error) => {
       this.user.generateToast('No se ha podido encontrar su posición');
     });
  }

  getAddressFromCoords(lattitude, longitude) {

    const options: NativeGeocoderOptions = { useLocale: true, maxResults: 5 };

    this.nativeGeocoder.reverseGeocode(lattitude, longitude, options)
      .then((result: NativeGeocoderResult[]) => {

        alert(JSON.stringify(result));

        this.address = '';

        let responseAddress = [];

        for (let [key, value] of Object.entries(result[0])) {

          if ( value.length > 0 ){ responseAddress.push(value); }

        }

        responseAddress.reverse();

        for (let value of responseAddress) { this.address += value + ', '; }

        this.address = this.address.slice(0, -2);

      })
      .catch((error: any) => this.user.generateToast('Address Not Available!'));
  }

  UpdateSearchResults(){
    this.cambiaDireccion();
    if (this.autocomplete.input == '') {
      this.autocompleteItems = [];
      return;
    }
    const config = {
      types: ['geocode'],
      input: this.autocomplete.input,
      componentRestrictions: {country: 'es'}
    };

    if (this.autocomplete.input == this.global.nombreCalle){
      this.autocompleteItems = [];

    }else{
      this.GoogleAutocomplete.getPlacePredictions(config,
        (predictions, status) => {
           
          this.autocompleteItems = [];
          this.zone.run(() => { 
            predictions.forEach((prediction) => {
              this.autocompleteItems.push(prediction);
            });
          });
        });
    
    }
    if (this.autocomplete.input == '') {
      this.autocompleteItems = [];
      return;
    }
  }

  ClearAutocomplete(){
    if (this.autocomplete.input == '') {
      this.autocompleteItems = []
      this.autocomplete.input = ''  
    }
    
  }

  async SelectSearchResult(place){
    
    this.global.disabled = false;
    const loading = await this.stop.create(loadOpt);
    await loading.present();
    this.global.nombreCalle = place.description;
    this.autocomplete.input = place.description;
    this.autocompleteItems = [];
    this.address = place.structured_formatting.main_text; 

    this.placesService.getDetails({placeId: place.place_id}, (details) => {

        details.address_components.forEach(add => {
          if ( add.types[0] === 'postal_code' ){ this.postal_code = add.long_name; }
        });
        details.address_components.forEach(add => {
        });
        this.lat = details.geometry.location.lat();
        this.lng = details.geometry.location.lng();
        loading.dismiss();

    });
    this.autocompleteItems = [];
    setTimeout(() => loading.dismiss(), 4500);
  }

  async presentModal() {
    const modal = await this.modalCtrl.create({
      component: MapComponent,
      cssClass: 'my-custom-class',
      componentProps: {
        'firstName': 'Douglas',
        'lastName': 'Adams',
        'middleInitial': 'N'
      }
    });
    this.ClearAutocomplete();
    return await modal.present();
  }

  cambiaDireccion(){
    if (this.autocomplete.input == this.global.nombreCalle) {
      this.global.disabled = false;  
    }else{
      this.global.disabled = true;
    }
    
  }
  
  clearSugerencias(){
    this.autocompleteItems = [];
  }


}




/* 

                   `\-.   `
                      \ `.  `
                       \  \ |
              __.._    |   \.      
       ..---~~     ~ . |    Y
         ~-.          `|    |
            `.               `~~--.
              \                    ~.
               \                     \__. . -- -  .
         .-~~~~~      ,    ,            ~~~~~~---...._
      .-~___        ,'/  ,'/ ,'\          __...---~~~
            ~-.    /._\_( ,(/_. 7,-.    ~~---...__
           _...>-  P""6=`_/"6"~   6)    ___...--~~~
            ~~--._ \`--') `---'   9'  _..--~~~
                  ~\ ~~/_  ~~~   /`-.--~~
                    `.  ---    .'   \_
                      `. " _.-'     | ~-.,-------._
                  ..._../~~   ./       .-'    .-~~~-.
            ,--~~~ ,'...\` _./.----~~.'/    /'       `-
        _.-(      |\    `/~ _____..-' /    /      _.-~~`.
       /   |     /. ^---~~~~       ' /    /     ,'  ~.   \
      (    /    (  .           _ ' /'    /    ,/      \   )
      (`. |     `\   - - - - ~   /'      (   /         .  |
       \.\|       \            /'        \  |`.           /
       /.'\\      `\         /'           ~-\         .  /\
      /,   (        `\     /'                `.___..-      \
     | |    \         `\_/'                  //      \.     |
     | |     |                             /' |       |     |

*/